import { Injectable } from '@angular/core';
import { ContactService } from '../services/contact.service';
import { AppConfigService } from 'common';

@Injectable()
export class PermissionsResolver {

  constructor(private env: AppConfigService, private contactService: ContactService) { }

  resolve() {
    return this.contactService.getApplicationPermissions(this.env.config.applicationId);
  }
}
